import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export class CommonFunctions {
  sanitizeHtml (html: string, _sanitizer: DomSanitizer): string | null {
    return _sanitizer.sanitize(SecurityContext.HTML, html);
  }
}
